import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";

interface IChangeSimEsimPeselVerificationErrorProps {
  userId: string | undefined;
}

export function ChangeSimEsimPeselVerificationError({
  userId,
}: IChangeSimEsimPeselVerificationErrorProps) {
  return (
    <Panel testId="incorrect-pesel-info-panel">
      <div className="flex flex-col items-center  justify-center">
        <Text
          align="center"
          size={{ "@onlyMobile": "xl", "@fromTablet": "keyM" }}
          weight="bold"
        >
          twój PESEL jest zastrzeżony
        </Text>
        <Separator size="m" tone="invisible" />
        <Icon
          className="w-[60px] h-[60px] from-tablet:w-[90px] from-tablet:h-[90px]"
          name="wallet-incircle-fail"
        />
        <Separator size="m" tone="invisible" />
        <Text align="center" size={{ "@onlyMobile": "m", "@fromTablet": "xl" }}>
          Odblokuj numer PESEL na czas wymiany lub zamówienia karty.{" "}
          <Separator size="none" tone="invisible" /> Najszybciej zrobisz to w
          aplikacji mObywatel.
        </Text>
        <Separator size="m" tone="invisible" />
        <div className="only-mobile:w-full">
          <Link
            href={portalRoutes.mojeKonto.index.get({
              mode: "mobile",
              ...(userId && { userId }),
            })}
            passHref={true}
          >
            <A
              className="only-mobile:w-full"
              size={{
                "@onlyMobile": "s",
              }}
              testId="ok-button"
              variant="primary"
            >
              ok
            </A>
          </Link>
        </div>
      </div>
    </Panel>
  );
}
